@if (isVisible) {
  <div class="modal" data-test="admin-settings-modal">
    <div class="backdrop" (click)="close()"></div>
    <div class="modal-content">
      <span class="close-button" (click)="close()">&times;</span>
      <h2 class="neon">Admin {{ "account-admin.title.quick-settings" | translate }}: {{ environment | uppercase }}</h2>
      <p>SiteId: {{ siteId }}</p>
      <p>Environment: {{ environment }}</p>
      <div class="admin-menu-theme-language-container">
        <div>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Theme</mat-label>
            <mat-select [(ngModel)]="settings.adminTheme">
              @for (theme of themes; track theme) {
                <mat-option [value]="theme.value">{{ theme.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <p>Forces the selected theme.</p>
        </div>
        <div>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>App theme</mat-label>
            <mat-select [(ngModel)]="settings.appTheme">
              @for (appTheme of appThemes; track appTheme.value) {
                <mat-option [value]="appTheme.value">{{ appTheme.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <p>Switches the app font and color theme (Inter + gold in 2026 themes; blue-gold keeps blue buttons).</p>
        </div>
        <div>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>User language</mat-label>
            <mat-select [(ngModel)]="settings.adminLanguage">
              @for (language of languages; track language) {
                <mat-option [value]="language.value">{{ language.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <p>Forces the selected language.</p>
        </div>
        <div>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Account language</mat-label>
            <mat-select [(ngModel)]="settings.adminAccountLanguage" name="adminAccountLanguage">
              <mat-option [value]="null">Reset</mat-option>
              @for (language of adminAccountLanguages; track language.code) {
                <mat-option [value]="language.code">
                  {{ language.name | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <p>Forces the account language.</p>
        </div>
      </div>

      <div>
        <br />
        <div>
          <b>Test Features</b>
        </div>
        <div>
          <label class="admin-switch-row">
            <span class="admin-switch">
              <input type="checkbox" role="switch" class="admin-switch__input" [(ngModel)]="settings.adminToggle" data-test="admin-settings-admin-toggle" />
              <ng-container [ngTemplateOutlet]="switchGoo" />
            </span>
            Admin Toggle
          </label>
          <p>View admin features.</p>
        </div>
        <div>
          <label class="admin-switch-row">
            <span class="admin-switch">
              <input type="checkbox" role="switch" class="admin-switch__input" [(ngModel)]="settings.aiFeatures" data-test="admin-settings-ai-features" />
              <ng-container [ngTemplateOutlet]="switchGoo" />
            </span>
            AI Features
          </label>
          <p>Enable AI Assistant (Template Suggestions).</p>
          <p>Show the work-in-progress agent assistant panel (sidebar button and floating launcher).</p>
        </div>
        <div>
          <label class="admin-switch-row">
            <span class="admin-switch">
              <input
                type="checkbox"
                role="switch"
                class="admin-switch__input"
                [(ngModel)]="settings.showServerSideCampaigns"
                data-test="admin-settings-server-side-campaigns" />
              <ng-container [ngTemplateOutlet]="switchGoo" />
            </span>
            Server-side campaigns
          </label>
          <p>Show the campaign menu action that switches a campaign between website and server-side (API only) delivery.</p>
        </div>
        <div>
          <label class="admin-switch-row">
            <span class="admin-switch">
              <input
                type="checkbox"
                role="switch"
                class="admin-switch__input"
                [(ngModel)]="settings.cookieFeatures"
                data-test="admin-settings-cookie-features" />
              <ng-container [ngTemplateOutlet]="switchGoo" />
            </span>
            Cookie features
          </label>
          <p>Show settings for Website Privacy page, cookieless tracking</p>
        </div>
        <div>
          <label class="admin-switch-row">
            <span class="admin-switch">
              <input
                type="checkbox"
                role="switch"
                class="admin-switch__input"
                [(ngModel)]="settings.versionHistory"
                data-test="admin-settings-version-history" />
              <ng-container [ngTemplateOutlet]="switchGoo" />
            </span>
            Version history
          </label>
          <p>Show version history and restore for campaigns in the editor.</p>
        </div>
        <div>
          <label class="admin-switch-row">
            <span class="admin-switch">
              <input type="checkbox" role="switch" class="admin-switch__input" [(ngModel)]="settings.undoRedo" data-test="admin-settings-undo-redo" />
              <ng-container [ngTemplateOutlet]="switchGoo" />
            </span>
            Undo and redo
          </label>
          <p>Undo and redo changes in the campaign editor, and show Undo instead of asking before a delete.</p>
        </div>
      </div>
      @if (currentUser && EarlyAccessFeaturesKeys?.length > 0) {
        <br />
        <div>
          <b>{{ "settings.profile.early-access.title" | translate }}</b>
        </div>
        @for (feature of EarlyAccessFeaturesKeys; track feature) {
          <label class="admin-switch-row">
            <span class="admin-switch">
              <input
                #featureSwitch
                type="checkbox"
                role="switch"
                class="admin-switch__input"
                [checked]="currentUser.earlyAccessFeatures?.includes(feature)"
                (change)="toggleFeature(feature, featureSwitch.checked)"
                [attr.data-test]="'admin-settings-early-access-' + feature" />
              <ng-container [ngTemplateOutlet]="switchGoo" />
            </span>
            {{ "settings.profile.early-access." + feature | translate }}
          </label>
          <p>{{ "settings.profile.early-access." + feature + "-description" | translate }}</p>
        }
      }

      <div class="admin-menu-button-container">
        @if (isDevelopment || isStaging) {
          <button class="secondary-button create-button" mat-stroked-button [disabled]="isLoading" (click)="createBlankTemplate()">
            @if (!isLoading) {
              <span class="btn-label">Create blank campaign</span>
            }
            @if (isLoading) {
              <mat-spinner diameter="24"></mat-spinner>
            }
          </button>
        }

        <button class="secondary-button save-button" mat-stroked-button (click)="toUserSetting()">
          <span class="btn-label">To User Setting</span>
        </button>

        <button class="secondary-button save-button" mat-stroked-button (click)="resetBrandVariables()">
          <span class="btn-label">Reset brand settings</span>
        </button>

        <button class="primary-button save-button" mat-stroked-button (click)="close()" data-test="save-button">
          <span class="btn-label">Save and apply</span>
        </button>
      </div>

      <svg class="admin-switch__defs" width="0" height="0" aria-hidden="true">
        <defs>
          <filter id="admin-settings-goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="3" result="blur" />
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo" />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
      </svg>
    </div>
  </div>
}

<ng-template #switchGoo>
  <span class="admin-switch__goo" aria-hidden="true">
    <span class="admin-switch__blob"></span>
    <span class="admin-switch__echo"></span>
  </span>
</ng-template>
